import { useContext, createContext } from "react";
import axios from "axios";
import useAuth from "./use-auth";

const axiosConfig = {
  timeout: 360 * 1000,
};

const CREDomain = process.env.REACT_APP_SERVER_URL;
const CRECareDomain = process.env.REACT_APP_TEST_API_URL;
const CREBaseDomain = process.env.REACT_APP_BASE_URL;

const ApiContext = createContext();
const useApi = () => useContext(ApiContext);

const useApiProvider = () => {
  const { signOut } = useAuth();
  const _axios = axios.create(axiosConfig);
  _axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        signOut();
      }
      return error;
    }
  );

  const handleResult = ({ result, onSuccess, onFail }) => {
    if (result.status >= 200 && result.status < 300) {
      onSuccess(result.data, result.status);
    } else {
      if (result.status === 401) {
      } else {
        onFail(result.data, result.status);
      }
    }
  };

  const postCRECareLogin = async ({ params, onSuccess, onFail }) => {
    const url = CRECareDomain + "/api/cremember/login";
    const result = await _axios.post(url, params);
    handleResult({ result, onSuccess, onFail });
  };

  const patchCRECareChangePd = async ({
    params,
    headers,
    onSuccess,
    onFail,
  }) => {
    const url = CRECareDomain + "/api/cremember/Password";
    const result = await _axios.patch(url, params, { headers });
    handleResult({ result, onSuccess, onFail });
  };

  const patchCRECareForgetPd = async ({
    params,
    onSuccess,
    onFail,
  }) => {
    const url = CRECareDomain + "/api/cremember/ForgetPassword";
    const result = await _axios.patch(url, params);
    handleResult({ result, onSuccess, onFail });
  }

  const postCRELogin = async ({ params, onSuccess, onFail }) => {
    const url = CREDomain + "/old_staging_cre_api/api/JointWeb/login";
    const result = await _axios.post(url, params);
    handleResult({ result, onSuccess, onFail });
  };

  const getProfile = async ({ headers, depId ,onSuccess, onFail }) => {
    const url = CREDomain + `/old_staging_cre_api/api/JointWeb/profile/${depId}`;
    const result = await _axios.get(url, { headers });
    handleResult({ result, onSuccess, onFail });
  };

  const getContactInfo = async ({
    eBuildingCaseId,
    onSuccess,
    onFail,
  }) => {
    const url = CREBaseDomain + `/${eBuildingCaseId}/contactInfo`;
    const result = await _axios.get(url);
    handleResult({ result, onSuccess, onFail });
  };

  const getProgressList = async ({
    eBuildingCaseId,
    onSuccess,
    onFail,
  }) => {
    const url = CREBaseDomain + `/${eBuildingCaseId}/projectProgressList`;
    const result = await _axios.get(url);
    handleResult({ result, onSuccess, onFail });
  };

  const getProgressDetail = async ({
    projectProgressId,
    onSuccess,
    onFail,
  }) => {
    const url =
      CREBaseDomain + `/projectProgress/${projectProgressId}`;
    const result = await _axios.get(url);
    handleResult({ result, onSuccess, onFail });
  };

  const getProblemList = async ({
    eBuildingCaseId,
    onSuccess,
    onFail,
  }) => {
    const url = CREBaseDomain + `/${eBuildingCaseId}/getProjectQuestionList`;
    const result = await _axios.get(url);
    handleResult({ result, onSuccess, onFail });
  };

  const getCompany = async ({
    eDepartmentId,
    // headers,
    onSuccess,
    onFail,
  }) => {
    const url = CREDomain + `/old_staging_cre_api/api/JointWeb/getCompany/${eDepartmentId}`;
    const result = await _axios.get(url);
    handleResult({ result, onSuccess, onFail });
  };

  return {
    postCRECareLogin,
    patchCRECareChangePd,
    patchCRECareForgetPd,
    postCRELogin,
    getProfile,
    getProgressList,
    getProgressDetail,
    getProblemList,
    getCompany,
    getContactInfo,
  };
};

const ApiProvider = ({ children }) => {
  const api = useApiProvider();
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};

export default useApi;
export { ApiProvider };
